import get from "lodash/get";
// import "../styles/all.less"

import "video.js/dist/video-js.min.css"
import videojs from "video.js/dist/video.min.js"
import UAP from "ua-parser-js/dist/ua-parser.min.js"

let ua = new UAP(navigator.userAgent);
const isMobile = ua.getDevice().type == "mobile"

if (isMobile) {
    $("html").addClass("__mb");
}else{
    $("html").addClass("__pc");
}

$(__=>{

    setTimeout(__=>{
        Delighters.init();
    })

    get(window, "name");


    //菜单切换
    const ht = $("html");
    $(".menu-toggle").click(function(){
        ht.toggleClass("menu_expand")
    });


    //视频播放
    $(".video_box:visible").each(function(i){
        var me=$(this);
        const $video = me.find("video");
        const $thumb = me.find(".video-thumb").hide();
        let video = $video[0];


        var player = videojs(video, {
            autoplay:false,
            controls:true,
            // muted:true,
            preload:"auto",
            // src:"./static/video.mp4",
            poster:"./static/video-thumb.jpg",
        }, function onPlayerReady() {
            videojs.log('Your player is ready!');

            // In this context, `this` is the player that was created by Video.js.
            // this.play();

            // How about an event listener?
            this.on('ended', function() {
                //videojs.log('Awww...over so soon?!');
            });

            $(".vjs-big-play-button", me).hide();
        });


        return ;
        me.click(__=>{
            if (!video) {
                return;
            }
            video.play();
            $thumb.hide();


        })
    });


    //菜单高亮
    let [, filePath] = location.href.split(location.host);
    filePath = filePath.split(/\?|#/)[0];


    if (/^(\/|index\.html)$/.test(filePath)) {
        $("nav>a:first").addClass("light");
    }else{

        //file协议下没有自动高亮
        if (!location.href.startsWith("file")) {
            $("a[href]").each(function(i){
                var me=$(this);
                const url = me[0].href;
                let [, _filePath] = url.split(location.host);

                if (!_filePath) {
                    return;
                }
                _filePath = _filePath.split(/\?|#/)[0];
                if (_filePath == filePath) {
                    me.addClass("light")
                }
            });
        }
    }




});